import { render, staticRenderFns } from "./PaymentFormSidebar.vue?vue&type=template&id=ae4d5c24"
import script from "./PaymentFormSidebar.vue?vue&type=script&lang=ts"
export * from "./PaymentFormSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports